import axios from 'axios';
import { resolveAuthHeaderValue } from '@/utils/authToken';
import { apiUrl } from '@/utils/appConfig';

const mainApiClient = axios.create({
  baseURL: apiUrl(),
});

mainApiClient.interceptors.request.use(config => {
  const authHeaderValue = resolveAuthHeaderValue();
  if (!authHeaderValue) return config;
  const nextConfig = { ...config };
  if (!nextConfig.headers) nextConfig.headers = {};
  nextConfig.headers.Authorization = authHeaderValue;
  return nextConfig;
});

const normalizeString = value => String(value || '').trim();

export async function getCredentialsByType(type) {
  const normalizedType = normalizeString(type);
  const { data } = await mainApiClient.get(`/api/credentials/by-type/${encodeURIComponent(normalizedType)}`);
  return Array.isArray(data) ? data : [];
}

export async function createCredential(payload) {
  const { data } = await mainApiClient.post('/api/credentials', payload);
  return data;
}

export async function updateCredential(credentialId, payload) {
  const { data } = await mainApiClient.put(`/api/credentials/${encodeURIComponent(credentialId)}`, payload);
  return data;
}

export async function upsertWordpressCredentialByLabel({ label, login = 'admin', password }) {
  const normalizedLabel = normalizeString(label);
  const normalizedPassword = normalizeString(password);
  if (!normalizedLabel) throw new Error('Credential label is required');
  if (!normalizedPassword) throw new Error('Credential password is required');

  const credentials = await getCredentialsByType('WORDPRESS');
  const loweredLabel = normalizedLabel.toLowerCase();
  const existing = credentials.find(item => normalizeString(item?.label).toLowerCase() === loweredLabel);
  const payload = {
    label: normalizedLabel,
    type: 'WORDPRESS',
    login: normalizeString(login) || 'admin',
    password: normalizedPassword,
    token: null,
    botName: null,
  };

  if (existing?.id) {
    const credential = await updateCredential(existing.id, payload);
    return { action: 'updated', credential };
  }

  const credential = await createCredential(payload);
  return { action: 'created', credential };
}
